import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { IAppState } from '../../../../models/reduxState';
import { RequestCard } from '../../presentationalComponents/RequestDetails/RequestCard';
import {
  inFeedbackStateSelector,
  isRequestFeedbackEnabledSelector,
} from '../../reduxUpdater/selectors/requestFeedbackSelectors';
import { getRequestCardStyles } from '../../styles/requestCardStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    showFeedback:
      isRequestFeedbackEnabledSelector(state) &&
      inFeedbackStateSelector(state, _ownProps.request.RequestId),
  };
};

export const RequestCardContainer = connect(
  mapStateToProps
)(styled(RequestCard, getRequestCardStyles));
